import { getCookie, hasCookie, setCookie } from 'cookies-next';
import styles from './CookieConsent.module.scss';
import { EBaseTextColor, EBaseTextSize } from '@spinwise/react-component-library/BaseText';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState, OVERLAY_CMS_PAGE_SHOW } from '@spinwise/spinwise-core';
import { t } from 'i18next';
import { POSITIONS, EOverlayContentWidth } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { EPageSlugs } from 'Types/globals';
import classNames from 'classnames';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import { EBaseButtonSize, EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(true);

  const { auth } = useSelector((state: IApplicationState) => state.authReducer);

  const geoCode = getCookie('country');

  const dispatch = useDispatch();

  const handleModalClick = (slug: string) => {
    dispatch({
      type: OVERLAY_CMS_PAGE_SHOW,
      data: {
        show: true,
        data: {
          slug,
          position: POSITIONS.TOP,
          contentWidth: EOverlayContentWidth.LARGE,
        },
      },
    });
  };

  useEffect(() => {
    setShowConsent(hasCookie('cookieConsent'));
  }, []);

  const acceptCookie = () => {
    setShowConsent(true);
    setCookie('cookieConsent', 'true', {});
  };

  if (showConsent) {
    return null;
  }

  return geoCode === 'EE' ? (
    <div
      className={classNames(styles.cookie_container, {
        [styles.cookie_container__logged]: auth && auth.success,
      })}
    >
      <div className={styles.cookie_container__svg_block}>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="var(--cookie-color)" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_5356_310811"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="40"
            height="40"
          >
            <rect width="40" height="40" fill="var(--cookie-color)" />
          </mask>
          <g mask="url(#mask0_5356_310811)">
            <path
              d="M17.499 16.7083C18.221 16.7083 18.825 16.4653 19.311 15.9793C19.7977 15.4933 20.041 14.8893 20.041 14.1673C20.041 13.4446 19.7977 12.8403 19.311 12.3543C18.825 11.8683 18.221 11.6253 17.499 11.6253C16.777 11.6253 16.1727 11.8683 15.686 12.3543C15.2 12.8403 14.957 13.4446 14.957 14.1673C14.957 14.8893 15.2 15.4933 15.686 15.9793C16.1727 16.4653 16.777 16.7083 17.499 16.7083ZM14.166 25.0423C14.888 25.0423 15.492 24.7989 15.978 24.3123C16.464 23.8263 16.707 23.2223 16.707 22.5003C16.707 21.7783 16.464 21.1743 15.978 20.6883C15.492 20.2016 14.888 19.9583 14.166 19.9583C13.4434 19.9583 12.839 20.2016 12.353 20.6883C11.867 21.1743 11.624 21.7783 11.624 22.5003C11.624 23.2223 11.867 23.8263 12.353 24.3123C12.839 24.7989 13.4434 25.0423 14.166 25.0423ZM24.999 26.6673C25.471 26.6673 25.867 26.5076 26.187 26.1883C26.5064 25.8683 26.666 25.4723 26.666 25.0003C26.666 24.5283 26.5064 24.1323 26.187 23.8123C25.867 23.4929 25.471 23.3333 24.999 23.3333C24.527 23.3333 24.131 23.4929 23.811 23.8123C23.4917 24.1323 23.332 24.5283 23.332 25.0003C23.332 25.4723 23.4917 25.8683 23.811 26.1883C24.131 26.5076 24.527 26.6673 24.999 26.6673ZM19.999 36.6673C17.721 36.6673 15.5684 36.2296 13.541 35.3543C11.513 34.4796 9.74203 33.2853 8.22803 31.7713C6.71403 30.2573 5.5197 28.4863 4.64503 26.4583C3.7697 24.4309 3.33203 22.2783 3.33203 20.0003C3.33203 17.7223 3.7767 15.5556 4.66603 13.5003C5.5547 11.4449 6.7767 9.63928 8.33203 8.08328C9.88803 6.52795 11.7144 5.31295 13.811 4.43828C15.9084 3.56295 18.1517 3.18095 20.541 3.29228C21.291 3.31961 21.881 3.52095 22.311 3.89628C22.7417 4.27095 23.0127 4.83328 23.124 5.58328C23.2907 7.24995 23.9714 8.67361 25.166 9.85428C26.36 11.0349 27.7767 11.7086 29.416 11.8753C29.9994 11.9306 30.4507 12.1319 30.77 12.4793C31.0894 12.8266 31.3047 13.3196 31.416 13.9583C31.5267 14.9309 31.8877 15.7713 32.499 16.4793C33.1104 17.1879 33.8744 17.7366 34.791 18.1253C35.485 18.4306 35.978 18.8263 36.27 19.3123C36.5614 19.7989 36.6794 20.4033 36.624 21.1253C36.5127 23.2639 35.9987 25.2779 35.082 27.1673C34.1654 29.0559 32.957 30.7016 31.457 32.1043C29.957 33.5069 28.228 34.6183 26.27 35.4383C24.3114 36.2576 22.221 36.6673 19.999 36.6673Z"
              fill="var(--cookie-color)"
            />
          </g>
        </svg>
      </div>
      <div className={styles.cookie_container__text_block}>
        {t('cookie.text')}
        <span onClick={() => handleModalClick(EPageSlugs.PRIVACY_POLICY)}> {t('cookie.link.text')}</span>
      </div>
      <div className={styles.cookie_container__btn}>
        <ButtonTextOnly
          textColor={EBaseTextColor.Secondary}
          textSize={EBaseTextSize.Small}
          type={EBaseButtonType.None}
          label={t('cookie.btn.text')}
          size={EBaseButtonSize.Small}
          onClick={() => acceptCookie()}
        />
      </div>
    </div>
  ) : null;
};
export default CookieConsent;
